var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesBranco10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.09,40.06H0.43v15.15h4.66v4.4h7.54V34.86H5.09V40.06z M3.31,52.33v-9.39h1.78v9.39H3.31z M7.97,37.74h1.78 v19H7.97v-1.53V40.06V37.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.57,39.26h-4.66v-4.4h-7.54v8.61H14.71v2.88h32.67v1.78H14.71V51h32.67v8.61h7.54v-5.2h4.66V39.26z  M52.04,56.74h-1.78V51v-7.54v-5.73h1.78v1.53v15.15V56.74z M56.69,51.53h-1.78v-9.39h1.78V51.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,23.98c5.69,0,10.32-4.63,10.32-10.32V10.7c0-5.69-4.63-10.32-10.32-10.32c-5.69,0-10.32,4.63-10.32,10.32 v2.96C19.68,19.35,24.31,23.98,30,23.98z M22.57,10.7c0-4.1,3.34-7.44,7.44-7.44s7.44,3.34,7.44,7.44v2.96 c0,4.1-3.34,7.44-7.44,7.44s-7.44-3.34-7.44-7.44V10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,28.6c3.66,0,7.04,1.22,9.78,3.26h4.3c-3.53-3.76-8.52-6.13-14.08-6.13s-10.55,2.37-14.08,6.13h4.3 C22.96,29.82,26.34,28.6,30,28.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesBranco10);
export default __webpack_public_path__ + "static/media/Icones_Branco-10.12a52adf9187c6f3adab496533fd5480.svg";
export { ForwardRef as ReactComponent };